/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.filter('UserPhotoUrl', () => (function(login, size) {
    if (-1 === ['extra-small', 'small', 'medium', 'large'].indexOf(size)) {
		size = "medium";
	}
    if (!login) {
		return `https://trombine.etna.io/blank/${size}`;
	} else {
		return `https://trombine.etna.io/${login}/${size}`;
	}
}));
